import Button from 'atoms/Button';

import Modal from 'atoms/Modal';
import { colors } from 'constants/colors';
import ColoredDot from 'layout/atoms/ColoredDot';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/index';
import { closeModal } from 'store/layoutSlice';
import { setProjectColor } from 'store/projectsThunks';
import { selectProject } from 'store/workspaceSlice';
import styles from './Project.module.scss';

type ChangeColorProps = {
    workspaceId?: string;
    projectId?: string;
};

export const ChangeColor = ({ workspaceId, projectId }: ChangeColorProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const project = useSelector((state: RootState) =>
        selectProject(state, projectId || '')
    );

    const handleClose = () => {
        dispatch(closeModal({ name: 'changeColor' }));
    };

    const handleColorChange = (color: string) => {
        if (!projectId || !workspaceId) return;
        dispatch(
            setProjectColor({
                projectId,
                command: {
                    workspaceId,
                    color: color,
                },
            })
        );
    };

    if (!project) {
        return null;
    }

    return (
        <Modal open={true} size="s" onClose={handleClose}>
            <header>
                <h2>Change color</h2>
            </header>
            <main className={styles.colorsList}>
                {colors.map((color: string) => (
                    <Button
                        key={color}
                        theme={project.color === color ? 'plain' : 'blank'}
                        shape="square"
                        onClick={() => handleColorChange(color)}
                    >
                        <ColoredDot color={color} />
                    </Button>
                ))}
            </main>
            <footer>
                <Button theme="plain" onClick={handleClose}>
                    <span>Close</span>
                </Button>
            </footer>
        </Modal>
    );
};
